import React from 'react'
import style from "css/template.module.css";
import { Link } from 'react-router-dom';
import { useTranslation } from "react-i18next";

function MobileSmartSolution() {
    const { t } = useTranslation();
    return (
        <ul className={style.smart_solution_list}>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/allplace`}
                >
                    <div className={`${style.smart_solution_icon} ${style.allplace}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/all_place.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>all Place</p>
                        <p>{t("solutionCard.allplace")}</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/begate`}
                >
                    <div className={`${style.smart_solution_icon} ${style.begate}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/be_gate.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>Be Gate</p>
                        <p>{t("solutionCard.begate")}</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/privateConnectManager`}
                >
                    <div className={`${style.smart_solution_icon} ${style.private}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/private_connect_manager.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>Private Connect Manager</p>
                        <p>{t("solutionCard.privateConnect")}</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/cmsmanager`}
                >
                    <div className={`${style.smart_solution_icon} ${style.cms}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/cms_manager.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>CMS Manager</p>
                        <p>{t("solutionCard.cms")}</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                    to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/deviceOne`}
                >
                    <div className={`${style.smart_solution_icon} ${style.deviceone}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/device_one.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>DeviceOne</p>
                        <p>{t("solutionCard.deviceOne")}</p>
                    </article>
                </Link>
            </li>
            <li>
                <Link
                    className={style.smart_solution_item}
                // to={`${process.env.REACT_APP_CLIENT_URL}smart-solution/deviceOne`}
                >
                    <div className={`${style.smart_solution_icon} ${style.medilink}`}>
                        <img
                            src={`${process.env.REACT_APP_CLIENT_URL}img/header/medi_link.png`}
                            alt=""
                        />
                    </div>
                    <article className={style.smart_solution_article}>
                        <p>MediLink</p>
                        <p>{t("solutionCard.mediLink")}</p>
                    </article>
                </Link>
            </li>
        </ul>
    )
}

export default MobileSmartSolution
